import { render, staticRenderFns } from "./OFPanel.vue?vue&type=template&id=e570805a&scoped=true"
import script from "./OFPanel.vue?vue&type=script&lang=js"
export * from "./OFPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e570805a",
  null
  
)

export default component.exports